(ns common.schema.entities.survey.survey-process
  (:require
   [common.data-types :as data-types]
   [common.schema.entities.survey.survey-auth-type :as survey-auth-type]
   [common.schema.entities.survey.survey-process-status :as survey-process-status]
   [common.schema.entities.survey.survey-sharing-type :as survey-sharing-type]
   [common.schema.entities.survey.survey-reference-periods :as survey-reference-periods]
   [common.schema.entities.survey.survey-template :as survey-template]
   [common.schema.schema-utils :as su]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def schema
  (concat
   (su/single-ref-field :survey-process/inviter
                        "Inviter"
                        [:entity.type/account]
                        {:authorization            su/access-user-user
                         :default-field-visibility :in-use-disabled})
   (su/keyword-field :survey-process/status
                     "Status"
                     survey-process-status/options
                     {:authorization            su/access-user-sug
                      :default-field-visibility :in-use-disabled})
   (su/text-edn-field :survey-process/burned-survey-config
                      "Survey config"
                      (system-controlled {:authorization            su/access-system-sug
                                          :default-field-visibility :in-use-disabled}))
   (su/single-ref-field :survey-process/template
                        "Template"
                        [:entity.type/survey-template]
                        {:authorization            su/access-user-sug
                         :default-field-visibility :in-use-disabled})
   (su/keyword-field :survey-process/language
                     "Default language"
                     survey-template/template-language-options
                     {:authorization            su/access-user-sug
                      :default-field-visibility :in-use-disabled})
   (su/text-edn-field :survey-process/localized-labels
                      "Localized labels"
                      {:authorization            su/access-user-sug
                       :default-field-visibility :in-use-disabled})
   (su/calculated-field :survey-process/english-label
                        "ENG label"
                        {:default-field-visibility :in-use-disabled
                         :data-type                :data.type/text-simple
                         :calculation-triggers     {}
                         :calc-fn                  (fn [{:keys [entity-data]}]
                                                     (->> entity-data
                                                          :survey-process/localized-labels
                                                          (data-types/parse-edn-string)
                                                          :ENG))})

   (su/single-ref-field :survey-process/target
                        "Target"
                        [:entity.type/company]
                        {:authorization            su/access-user-user
                         :default-field-visibility :in-use-disabled})
   (su/multi-ref-field :survey-process/answers
                       "Answers"
                       [:entity.type/survey-answer]
                       {:authorization            su/access-user-sug
                        :default-field-visibility :in-use-disabled})
   (su/datetime-field :survey-process/approval-date
                      "Process approval date"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
   (su/datetime-field :survey-process/invited-date
                      "Process invitation time"
                      (system-controlled {:authorization            su/access-system-user
                                          :default-field-visibility :in-use-disabled}))
   ;; These two had their arguments a place out - `nil` where the label goes
   ;; and the label where the options go - so both fields carried no name and
   ;; a bare string as their option list. Invisible so far only because both
   ;; are :in-use-disabled and never render in configuration.
   (su/keyword-field :survey-process/auth-type
                     "Authentication"
                     survey-auth-type/options
                     {:authorization            su/access-user-sug
                      :default-field-visibility :in-use-disabled})
   (su/keyword-field :survey-process/sharing-type
                     "Re-sharing"
                     survey-sharing-type/options
                     {:authorization            su/access-user-sug
                      :default-field-visibility :in-use-disabled})
   (su/text-edn-field :survey-process/invitees
                      "Invitees"
                      (system-controlled {:authorization            su/access-system-user
                                          :default-field-visibility :in-use-disabled
                                          :filter-edn?              true}))
   (su/text-simple-multi-field :survey-process/invited-emails
                               "Invited emails"
                               (system-controlled {:authorization su/access-system-system}))

   (su/text-simple-field :survey-process/invite-token
                         "token"
                         (system-controlled {:authorization            su/access-system-user
                                             :default-field-visibility :in-use-disabled}))

   (su/text-simple-field :survey-process/label
                         "Label"
                         {:authorization            su/access-user-sug
                          :default-field-visibility :in-use-disabled})
   (su/datetime-field :survey-process/timestamp-period-start
                      "Target period start"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
   (su/datetime-field :survey-process/timestamp-period-end
                      "Target period end"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
   (su/calculated-field :survey-process/reference-period-label
                        "Reference period"
                        {:default-field-visibility :in-use-disabled
                         :data-type                :data.type/text-simple
                         :calculation-triggers     {}
                         :calc-fn                  (fn [{:keys [entity-data]}]
                                                     (let [start-ts (:survey-process/timestamp-period-start entity-data)
                                                           end-ts (:survey-process/timestamp-period-end entity-data)
                                                           option-value (str start-ts "-" end-ts)]
                                                       (survey-reference-periods/label-by-option-value option-value)))})

   (su/text-edn-field :survey-process/burned-templates
                      "Burned templates"
                      (system-controlled {:authorization            su/access-system-sug
                                          :default-field-visibility :in-use-disabled
                                          :hidden-from-config?      true}))

   (su/datetime-field :survey-process/deadline
                      "Deadline"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})

   (su/multi-ref-field :survey-process/survey-reminders
                       "Survey reminders"
                       [:entity.type/survey-reminder]
                       {:authorization            su/access-user-user
                        :editor-type              :editor.type/none
                        :grid-type                :editor.type/none
                        :filter-type              :filter.type/none
                        :default-field-visibility :in-use-disabled})

   (su/boolean-field :survey-process/show-previous-response?
                     "Show previous response"
                     {:authorization            su/access-user-sug
                      :default-field-visibility :in-use-disabled})))
